export const setShowTopSections = (isShow) => {
  return async (dispatch) => {
    dispatch({ type: "SET_SHOW_TOP_SECTIONS", payload: isShow });
  };
};

export const setShowMobileMenu = (isShow) => {
  return async (dispatch) => {
    dispatch({ type: "SET_SHOW_MOBILE_MENU", payload: isShow });
  };
};

export const setIsMobile = (isMobile) => {
  return async (dispatch) => {
    dispatch({ type: "SET_IS_MOBILE", payload: isMobile });
  };
};

export const setCityConfirmActive = (isActive) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CITY_CONFIRM_ACTIVE", payload: isActive });
  };
};
